export const NAV_ITEM_TEST_ID = 'sidebar-nav-item';
